import { DOMAIN } from "js/constants";
import md5 from 'md5';

// Hash the Less content to create a unique identifier for caching
function hashString(str) {
  return md5(str);
}

// Retrieve cached CSS from sessionStorage based on the hash of the Less content
function retriveCachedCss(lessHash) {
  if (!window.sessionStorage) {
    console.warn('Session storage is not supported. Caching is disabled.');
    return null;
  }

  const cached = sessionStorage.getItem(`less_${lessHash}`);
  if (cached) {
    console.log('Cached CSS found for hash:', lessHash);
    return cached;
  } else {
    console.log('No cached CSS found for hash:', lessHash);
    return null;
  }
}

// Cache the compiled CSS in sessionStorage using the hash of the Less content as the key
function cacheCss(lessHash, cssContent) {
  if (!window.sessionStorage) {
    console.warn('Session storage is not supported. Caching is disabled.');
    return;
  }

  try {
    sessionStorage.setItem(`less_${lessHash}`, cssContent);
    console.log('CSS cached successfully for hash:', lessHash);
  } catch (e) {
    console.error('Failed to cache CSS:', e);
  }
}

// Compile Less content by sending it to the server and return the compiled CSS
// If force is true, it will bypass the cache and recompile the Less content
// Returns the compiled CSS or the original Less content in case of an error
async function compileLess(lessContent, force = false) {

  let lessHash = hashString(lessContent);
  console.log(`Less content hash: ${lessHash}`);

  if (!force) {
    const cachedCss = retriveCachedCss(lessHash);
    if (cachedCss) {
      console.log('Using cached CSS for hash:', lessHash);
      return cachedCss;
    }
  }

  return await fetch(`/api/less/compile`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ less: lessContent })
  })
    .then(response => response.json())
    .then(data => {
      if (data.success) {
        console.log('Less compilation successful');
        cacheCss(lessHash, data.css);
        return data.css;
      } else {
        return data.css;
      }
    })
    .catch(error => {
      console.error('Error during Less compilation:', error);
      return lessContent; // Return original Less content on error
    });
}

export { compileLess };